import React, {useEffect} from 'react';
import { useSelector, useStore } from 'react-redux';
import playButton from './dumpert-play.svg';
import {
  fetchItemOp,
  selectItemDetails,
  selectItemId,
  selectItemIsLoaded,
  selectItemStatus,
} from '../../ducks';
import { Loading } from '../loading';
import { NotFound } from '../NotFound';
import { ItemMetaTags } from '../itemdetail/ItemMetaTags';
import { VideoEmbed } from '../item/VideoEmbed';
import styles from './ItemEmbeddedViewPage.css';
import { increaseView } from '../../apis/dumpert';

export const ItemEmbeddedViewPage = ({ match: { params }, staticContext }) => {
  const status = useSelector(selectItemStatus);
  const item = useSelector(selectItemDetails);
  const { dispatch, getState } = useStore();
  const { itemId } = params;

  useEffect(() => {
    if (!itemId) {
      return;
    }
    const state = getState();
    if (!selectItemIsLoaded(state) || selectItemId(state) !== itemId) {
      dispatch(fetchItemOp(itemId));
    }
    increaseView(itemId).then(
      () => { /* no-op */
      },
    );
  }, [itemId]);

  if (status === 'loading') {
    return <div className={styles.loadscreen}><Loading whatIsLoading='item' /></div>;
  }
  if (status === 'error') {
    return <NotFound staticContext={staticContext}/>;
  }
  if (!item || !item.media) {
    return null;
  }

  const { mediatype, variants } = item.media[0];
  const { nopreroll, nsfw } = item;
  const [{ version, uri }] = variants;
  const isVideo = mediatype === 'VIDEO';
  const isEmbed = isVideo && version === 'embed';

  if (mediatype === 'FOTO') {
    return (
      <div className={styles.embed}>
        <div className={styles.nsfw_message}>
          <h2>
            Hoi. Het embedden van plaatjes wordt niet ondersteund,
            want je kan het plaatje ook gewoon opslaan en gebruiken, zoals alle andere mensen doen.
          </h2>
        </div>
      </div>
    );
  }

  if (!isVideo ) {
    return <div>☹</div>; // other mediatypes are not supported
  }

  if(nopreroll || nsfw) {
    return (
      <div className={styles.embed}>
        <div className={styles.nsfw_message}>
          <h2>
            HOI GLUURDER. DIT ITEM BEVAT SCHOKKENDE BEELDEN.
            GA NAAR <a href='https://dumpert.nl' rel='noopener noreferrer' target='_blank'>DUMPERT</a>.NL&nbsp;
            EN ZET EVENTUEEL 'TOON NSFW ITEMS' AAN OM DIT ITEM TE BEKIJKEN.
          </h2>
        </div>
      </div>
    );
  }

  return (
    <>
      <ItemMetaTags
        item={item}
        url={`//${staticContext ? staticContext.request.get('host') : window.location.host}/item/${item.id}`}
        embedded={true}
      />
      {isEmbed && <VideoEmbed uri={uri} />}
      {isVideo && version !== 'embed' && (
        <a href={`https://dumpert.nl/item/${item.id}`}
          rel='noopener noreferrer'
          target='_blank'
        >
          <div
            className={styles.embed}
            style={{
              'backgroundImage': `url(${item.still ? item.still : ''})`,
              'backgroundSize': 'cover',
              'backgroundPosition': 'center center',
            }}
          >
            <div className={styles.playbutton}
              style={{
                'backgroundImage': `url(${playButton})`,
                'backgroundSize': '105%',
                'backgroundPosition': 'center center',
              }}
            >
            </div>
          </div>
        </a>
      )}
    </>
  );
};

ItemEmbeddedViewPage.serverFetch = ({ params }) => fetchItemOp(params.itemId);
